import { render } from "./PhoneCallResponse.vue?vue&type=template&id=346243dd&scoped=true"
import script from "./PhoneCallResponse.vue?vue&type=script&lang=js"
export * from "./PhoneCallResponse.vue?vue&type=script&lang=js"

import "./PhoneCallResponse.vue?vue&type=style&index=0&id=346243dd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src745183879/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346243dd"]])

export default __exports__